/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-26 17:34:19
 * @LastEditTime: 2022-01-26 22:15:39
 * @LastEditors: zhao - 🍉
 * @Description: 租金宝同步数据 - 房源详情
 * @FilePath: /zhzj-admin/src/page/ZJBSyncDataRecord/components/HouseDetailListModal.jsx
 */
import { Button, Modal } from 'antd'
import React, { useState, forwardRef, useImperativeHandle } from 'react'
import ModalScrollContainer from "../../../components/ModalScrollContainer";
import TableHelper from '../../../components/TableHelper'
import { fetchZJBSyncDataHouseInfo } from '../../../services/ZJBSyncDataRecord'
import { dicBuildingStatus, mapZJBSyncDataDetailType } from "../../../axios/dictionaries";
import { findDict, formatTime } from '../../../utils';


const HouseDetailListModal = (props, ref) => {
    const [visible, setVisible] = useState(false);
    const [defaultSearch, setDefaultSearch] = useState(null);
    useImperativeHandle(ref, () => ({
        open
    }))
    const open = (operationType, syncDate) => {
        setVisible(true)
        setDefaultSearch({ operationType, syncStartDate: syncDate, syncEndDate: syncDate })
    }
    const close = () => {
        setVisible(false)
        setDefaultSearch(null)
    }
    const columns = [
        { title: '小区/楼栋名称', dataIndex: 'buildingName', width: 250 },
        { title: '房号', dataIndex: 'roomNo', },
        { title: '朝向', dataIndex: 'direct', },
        { title: '楼层', dataIndex: 'floor', },
        { title: '面积', dataIndex: 'area', },
        { title: '户型', dataIndex: 'layout', },
        { title: '租金（元）', dataIndex: 'rent', },
        { title: '商户简称', dataIndex: 'shortName', },
        { title: '状态', dataIndex: 'status', render: (text) => {
            return findDict(dicBuildingStatus, text).title
        }},
        { title: '更新时间', dataIndex: 'updateTime', render: formatTime}
    ]

    const searchOptions = [
        { key: 'operationType', type: 'select', options: mapZJBSyncDataDetailType },
        { key: 'syncStartDate', type: 'date', placeholder: '同步开始日期' },
        { key: 'syncEndDate', type: 'date', placeholder: '同步结束日期' },
    ]
    return (
        <Modal visible={visible} title="房源详情" width={950} destroyOnClose onCancel={close} footer={<Button onClick={close}>关闭</Button>}>
            {
                (visible && defaultSearch) && (
                    <ModalScrollContainer>
                        <TableHelper initialValue={defaultSearch} columns={columns} searchOptions={searchOptions} scroll={{ x: 2000 }} request={fetchZJBSyncDataHouseInfo} />
                    </ModalScrollContainer>
                )
            }
        </Modal>
    )
}

export default forwardRef(HouseDetailListModal)


// WEBPACK FOOTER //
// ./src/page/ZJBSyncDataRecord/components/HouseDetailListModal.jsx